export default "__VITE_PUBLIC_ASSET__296eb26b__"